import { defineMessages } from 'react-intl';

export default defineMessages({
    vendorsInvolved: {
        id: 'twia.claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    },
    messageInfo: {
        id: 'twia.claim.views.claim-detail.claim.views.claim-detail.Message Info',
        defaultMessage: 'Click on "Send Message" to send a message to the person handling this claim. Your message history is shown below, and you can also use the search field to filter your message history using key terms. Please note that you can also view and upload files for this claim through the Documents tab.'
    },
    sendMessage: {
        id: "twia.claim.views.claim-detail.Send Message",
        defaultMessage: "Send Message"
    },
    noMessageNote: {
        id: "twia.claim.views.claim-detail.No Message",
        defaultMessage: "There are no messages currently associated with the claim"
    },
    addMesageNote: {
        id: "twia.claim.views.claim-detail.Message Note",
        defaultMessage: "Your message will be sent to the person assigned to handle this claim"
    },
    disclaimerTFPA: {
        id: "twia.claim.views.claim-detail.Disclaimer TFPA",
        defaultMessage: "You should receive a response within one business day. If you need immediate assistance,please contact us 24 hours a day at {phoneNumber}."
    },
    disclaimerTWIA: {
        id: "twia.claim.views.claim-detail.Disclaimer TWIA",
        defaultMessage: "You should receive a response within one business day. Please contact us during business hours to reach the claims examiner assigned to your claim."
    },
    paymentsHeaderText: {
        id: 'twia.claim.views.claim-detail.Payments',
        defaultMessage: 'Payments'
    },
    noteMessage: {
        id: 'twia.claim.directives.claim-notes.Message',
        defaultMessage: 'Message'
    },
    paymentMethodText: {
        id: 'twia.claim.views.claim-detail.payment-method.Electronic Funds Tranfer',
        defaultMessage: 'Electronic Funds Transfer'
    },
    paymentMethodCheckText: {
        id: 'twia.claim.views.claim-detail.payment-method.Check',
        defaultMessage: 'Check'
    },
    createNoteSend: {
        id: 'twia.claim.views.create-note.Send',
        defaultMessage: 'Send',
    }
});
